import { useCallback } from 'react'
import { useQuery, useQueryClient } from '@tanstack/react-query'

export type Breadcrumb = {
  name: string
  to?: string
}

export const useBreadcrumbs = () => {
  const queryClient = useQueryClient()

  const query = useQuery<unknown, Error, Array<Breadcrumb>>({
    queryKey: ['breadcrumbs'],
  })

  const setBreadcrumbs = useCallback(
    (
      breadcrumbs: Array<Breadcrumb>,
      options: { setTitle?: boolean } = { setTitle: true }
    ) => {
      queryClient.setQueryData(['breadcrumbs'], breadcrumbs)
      if (options.setTitle && breadcrumbs.length > 0) {
        document.title = `${breadcrumbs[breadcrumbs.length - 1]?.name} | Ocarina`
      }
    },
    [queryClient]
  )

  return { breadcrumbs: query.data, setBreadcrumbs }
}
